// src/modules/app-views/_apps/appmulti/plans/pages/Init/components/PlansToolbarLeft/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useListContext } from 'components/core/ListProvider';
import FilterButton from 'layouts/Pages/PageHeader/FilterButton';

import PlansFilterPopover from '../PlansFilterPopover';
import PlansGlobalSearch from '../PlansGlobalSearch';
import './PlansToolbarLeft.less';

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const PlansToolbarLeft = () => {
  const { query } = useListContext() || {};

  const hasPopoverFilter = !!(
    query?.filter?.operatorId?.length || query?.filter?.priceType?.length
  );

  return (
    <div className="plans-toolbar-left">
      <PlansGlobalSearch />
      <FilterButton
        actions={['filter']}
        popoverContent={<PlansFilterPopover />}
        hasActiveFilter={hasPopoverFilter}
      />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default PlansToolbarLeft;
